import React from 'react';
function NotFound() {
  return <div style={{ padding: '6rem 2rem', textAlign: 'center' }}><h1>404 — Page Not Found</h1></div>;
}
export default NotFound;